import { EventEmitter } from 'fbemitter';
import type { Messages } from './types';

export const messagesEvent = new EventEmitter();

const getContent = async (response: Response) => {
    const contentType = response.headers.get('content-type');

    if (response.status === 204) {
        return;
    } else if (contentType?.startsWith('application/json')) {
        return response.json();
    }

    throw response;
};

const checkStatus = <T>(status: number, content: T): T => {
    if (status >= 200 && status < 300) {
        return content;
    }

    // eslint-disable-next-line no-throw-literal
    throw {
        ...content,
        status,
    };
};

const parseMessages = async <T>(response: Response) => {
    const content = await getContent(response);
    if (content && content.messages) {
        messagesEvent.emit('added', content.messages);
    }

    return content as T;
};

export const parseJSON = async <T>(response: Response) => {
    const content = await parseMessages<T>(response);

    return checkStatus<T>(response.status, content);
};

export interface ApiResponse<T, I> {
    data: T;
    included?: I;
    messages?: Messages;
}
